import { ISdColDef, ISdFilterDef } from "../../../../columns/baseColumn/BaseColumnTypes";
import { BASE_COLUMN_CONFIG, BASE_FILTER_CONFIG } from "../../../../columns/baseColumn/BaseColumn_config";

export const TOTAL_PEOPLE_IMPACTED_COLUMN_CONFIG = (columnOptions?: ISdColDef<any, any>): ISdColDef<any, any> => ({
  ...BASE_COLUMN_CONFIG,
  field: "totalPeopleImpacted",
  headerName: "totalPeopleImpacted",
  editable: true,
  ...columnOptions
});

export const TOTAL_PEOPLE_IMPACTED_FILTER_CONFIG: ISdFilterDef = {
  ...BASE_FILTER_CONFIG,
  filter: "agTextColumnFilter",
  filterParams: {
    buttons: ["clear"]
  }
};
